export const MODAL_TYPES = {
  FILTROS: "FILTROS",
  FILTROS_EXPORTER: "FILTROS_EXPORTER",
  CREAR_RECIBO: "CREAR_RECIBO",
  APLICAR_RECIBO: "APLICAR_RECIBO",
  DETALLE_FACTURA: "DETALLE_FACTURA",
  DETALLE_RECIBO: "DETALLE_RECIBO",
  ANULAR_FACTURA: "ANULAR_FACTURA",
  ANULAR_RECIBO: "ANULAR_RECIBO",
  DESAPLICAR_RECIBO: "DESAPLICAR_RECIBO",
  EN_DESARROLLO: "EN_DESARROLLO",
  VER_FACTURA: "VER_FACTURA",
  ENVIAR_POR_MAIL: "ENVIAR_POR_MAIL",
  ABRIR_NOTAS: "ABRIR_NOTAS",
};
